import styled from "@emotion/styled";
import { ExpertProjectRecord } from "@src/api/types";

import VerifiedIcon from "@mui/icons-material/Verified";
import { EmptySpace } from "@src/component/SignComponent";
import { GroupA } from "@src/ruix";

export const ProfileProjectItem = ({
	data,
	title,
	contribution,
	isOnePoint,
}: ExpertProjectRecord) => (
	<Wrapper>
		{isOnePoint && (
			<>
				<GroupA order="row-center-start">
					<VerifiedIcon sx={{ fill: "var(--primary)" }} />
					<div className="one-point">원포인트 진행 프로젝트</div>
				</GroupA>
				<EmptySpace space={4} />
			</>
		)}
		<div className="top">
			<div className="title-box">{title}</div>
			{contribution ? <div className="contribution">기여도 {contribution}%</div> : <></>}
		</div>
		<div className="content">{data}</div>
	</Wrapper>
);

const Wrapper = styled.div`
	display: flex;
	flex-direction: column;

	.one-point {
		color: var(--primary);
		font-size: 16px;
		font-weight: bold;
		letter-spacing: -0.64px;
	}

	.top {
		display: flex;
		flex-direction: row;
		justify-content: space-between;
		flex-wrap: wrap;
		align-items: flex-start;

		.title-box {
			color: var(--card-bg);
			font-size: 20px;
			font-weight: 700;
			line-height: normal;

			letter-spacing: -0.64px;
		}

		.contribution {
			color: var(--primary);
			white-space: pre-wrap;
			font-weight: 700;

			letter-spacing: -0.64px;
		}
	}

	.content {
		display: flex;
		flex-direction: column;
		margin-top: 24px;

		color: var(--desc-gray);
		font-size: 16px;
		font-weight: 400;
		line-height: 150%;
		letter-spacing: -0.64px;

		white-space: pre-wrap;
	}
`;
